import { headerMobileNavigationOpenState } from "../../../../src/modules/_common/states/NavigationStates";
import { useRecoilState } from "recoil";
import cc from "classcat";
import HeaderNavigationItem from "./HeaderNavigationItem";
import useAnonymousDataLayer from "../../../../src/_hooks/useAnonymousDataLayer";
import HeaderNavigationPipe from "./HeaderNavigationPipe";
import HorizontalSeparator from "../../images/_svgs/v2/horizontal-separator.svg";
import SVGImage from "../SVGImage";
import ButtonWithArrow from "./ButtonWithArrow";
import useTypeForm from "../../hooks/useTypeForm";

const HeaderNavigation = () => {
	const { event } = useAnonymousDataLayer();

	const [openSide, setOpenSide] = useRecoilState(headerMobileNavigationOpenState);
	const freeConsultationForm = useTypeForm("R6iu6OZO");

	return (
		<nav className="row flex-row-reverse flex-md-row align-items-center">
			<div className={cc(["col", { open: openSide }])} id="main-navigation-items-v2">
				<ul
					className={cc([
						"list-unstyled p-0 m-0 d-inline-flex d-md-flex flex-column flex-md-row align-items-center justify-content-start justify-content-md-end main-nav-list py-11 px-6 py-md-0 px-md-0 w-100",
					])}
				>
					<HeaderNavigationItem href="/for-organisations/">For Organisations</HeaderNavigationItem>
					<HeaderNavigationItem href="/for-individuals/">For Individuals</HeaderNavigationItem>
					<HeaderNavigationItem href="/who-we-are/">Why choose us</HeaderNavigationItem>
					<HeaderNavigationItem href="/blog/">Get Inspired</HeaderNavigationItem>
					<li className="nav-list-item d-none d-md-flex">
						<HeaderNavigationPipe component="div" className="mr-8" />
					</li>
					<li className="nav-list-item d-md-none mb-15">
						<SVGImage>
							<HorizontalSeparator />
						</SVGImage>
					</li>

					<li className="nav-list-item">
						<ButtonWithArrow
							text="Get in touch"
							isBlack={true}
							className="font-size-medium btn-hover-mid-green"
							onClick={() => {
								event("Get in touch Clicked", "Header", "Registration Interactions");
								freeConsultationForm.open();
							}}
						/>
					</li>
				</ul>
			</div>
			{openSide && (
				<div className="row m-0 colored-separator d-md-none">
					<div className="top-color-1 bg-pink"></div>
					<div className="top-color-2 bg-red"></div>
					<div className="top-color-3 bg-purple"></div>
					<div className="top-color-4 bg-dark-purple"></div>
				</div>
			)}
		</nav>
	);
};

export default HeaderNavigation;
